export default "__VITE_ASSET__7206e5c8__"